// extracted by mini-css-extract-plugin
export default {"message":"NoSeries-message-TxrpH","buttonContainer":"NoSeries-buttonContainer-Pow_F"};